import api from './api'
import { BASE } from './config'
import { DEFAULT_PAGINATION_LIMIT } from '@/constants/common'

class VisitsService {
  // visits
  getVisits({ params, cancelToken }) {
    return api.get(`${BASE}/visits/`, {
      params: { ...params, limit: DEFAULT_PAGINATION_LIMIT },
      cancelToken,
    })
  }

  getVisit(id) {
    return api.get(`${BASE}/visits/${id}/`)
  }

  getVisitHistory(id) {
    return api.get(`${BASE}/visits/${id}/history/`)
  }

  updateVisit({ uuid, data }) {
    return api.patch(`${BASE}/visits/${uuid}/`, data)
  }

  updateVisitClinicianLogin({ uuid, data }) {
    return api.post(`${BASE}/visits/${uuid}/emr-login/`, data)
  }

  declineVisit({ uuid, data }) {
    return api.post(`${BASE}/visits/${uuid}/decline_visit/`, data)
  }

  uploadVisitDocumentFile(file) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('document_type', 'document')

    return api.post(`${BASE}/files/visit_documents/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  // offers
  getOffers({ params, cancelToken }) {
    return api.get(`${BASE}/offers/`, {
      params: { ...params, limit: DEFAULT_PAGINATION_LIMIT },
      cancelToken,
    })
  }

  updateOffer({ offerId, body }) {
    return api.patch(`${BASE}/offers/${offerId}/`, body)
  }

  assignClinician({ offerId, data }) {
    return api.post(`${BASE}/offers/${offerId}/assign_clinician/`, data)
  }

  getOffer(id) {
    return api.get(`${BASE}/offers/${id}/`)
  }

  getOfferMatchedClinicians(id) {
    return api.get(`${BASE}/offers/${id}/matched_clinicians/`)
  }

  getOfferMatchedCliniciansCount(id) {
    return api.get(`${BASE}/offers/${id}/matched_clinicians_count/`)
  }

  createOffer({ body }) {
    return api.post(`${BASE}/offers/`, body)
  }

  createPatientOffer({ patientPk, body }) {
    return api.post(`${BASE}/patients/${patientPk}/offer/`, body)
  }

  rejectOffer(offerId, reason) {
    return api.post(`${BASE}/offers/${offerId}/reject_offer/`, {
      rejection_reason: reason,
    })
  }

  republishOffer({ uuid }) {
    return api.post(`${BASE}/offers/${uuid}/republish_offer/`)
  }

  deleteOffer({ uuid }) {
    return api.delete(`${BASE}/offers/${uuid}/`)
  }

  getVisitPayRates({ agencyUuid, disciplineUuid }) {
    return api.get(`${BASE}/offers/visit_pay_rates/`, {
      params: {
        agency_uuid: agencyUuid,
        discipline_uuid: disciplineUuid,
        limit: 1000,
      },
    })
  }
}

export default new VisitsService()
